import { useEatSessionQuery } from '~/libs/gql/queries/eat/eatSessionQuery.generated';

// Eat pages are cached at the edge, so the session is never server-rendered: it loads in the browser after hydration.
// Until then `loading` is true; render nothing user-specific (not even "Sign in") so signed-in visitors don't see a flash.
export const useEatSession = () => {
  const { data, loading } = useEatSessionQuery({ ssr: false });
  return {
    loading,
    user: data?.currentSession.user ?? null,
  };
};
